import createAsyncLocalStorage from './defaults/asyncLocalStorage';

export var asyncLocalStorage = createAsyncLocalStorage('local');
export var asyncSessionStorage = createAsyncLocalStorage('session');


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/redux-persist/es/defaultStorages.js
// module id = 301
// module chunks = 0 1